import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { handleGetRequest } from '../../../services/GetTemplate';
import { TabView, TabPanel } from 'primereact/tabview';
import { Accordion, AccordionTab } from 'primereact/accordion';

function Faqs() {
    const [faqList, setFaqList] = useState([]);
    const dispatch = useDispatch();

    const getFAQList = async () => {
        const response = await dispatch(handleGetRequest("api/FAQ", true, true));
        setFaqList(response?.data || []);
    };

    useEffect(() => {
        getFAQList();
    }, []);

    return (
        <TabView className="p-3 border-200 border-3 border-round">
            {faqList.map((category) => (
                <TabPanel key={category.categoryId} header={category.categoryName}>
                    <Accordion activeIndex={0}>
                        {category.FAQs.map((faq) => (
                            <AccordionTab key={faq._id} header={faq.question}>
                                <p className="m-0"  dangerouslySetInnerHTML={{ __html: faq.answer }}></p>
                            </AccordionTab>
                        ))}
                    </Accordion>
                </TabPanel>
            ))}
        </TabView>
    );
}

export default Faqs;
